import type { TableColumn } from '@/components/alerts/types'
import MarketSpreadTableActions from '@/components/monitoring/spreadsTableActions.vue'
import type { FormInstance } from '@primevue/forms'
import { markRaw, type ShallowRef } from 'vue'

export const getMarketSpreadAlertsTableColumns = (
  form: ShallowRef<FormInstance | null>,
): TableColumn[] => {
  return [
    {
      field: 'ex_buy.title',
      width: '110px',
      header: 'exBuy',
      class: 'text-center',
      inner: 'span',
      innerProps: {
        class: 'pit success',
      },
    },
    {
      field: 'ex_sell.title',
      width: '110px',
      header: 'exSell',
      class: 'text-center',
      inner: 'span',
      innerProps: {
        class: 'pit error',
      },
    },
    {
      field: 'symbol.name',
      width: '120px',
      header: 'symbol',
      class: 'text-center',
      inner: 'span',
      innerProps: {
        class: 'pit',
      },
    },
    {
      field: 'is_spot',
      width: '100px',
      header: 'marketType',
      class: 'text-center',
      inner: 'span',
      innerProps: {
        class: 'pit',
      },
    },
    {
      field: 'spread',
      width: '90px',
      header: 'spread',
      class: 'text-center',
      inner: 'span',
      innerProps: {
        class: 'pit digit',
      },
    },
    {
      field: 'backspread',
      width: '100px',
      header: 'backspread',
      class: 'text-center',
      inner: 'span',
      innerProps: {
        class: 'pit digit',
      },
    },
    {
      field: 'actions',
      width: '100px',
      header: '',
      class: 'text-center',
      dynamic: true,
      inner: markRaw(MarketSpreadTableActions),
      innerPropsGenerator: (data: object) => {
        return {
          form: form,
          ...data,
        }
      },
    },
  ]
}
